import { Component } from 'react'
import { connect } from 'react-redux'
import IconSVG from 'svg-inline-react'
import { Link } from 'react-router'
import { Button, Icon } from '@driftt/tide-core-legacy'
import { get } from 'lodash'
import { areWeOpenForBusiness } from 'utils/OpenHoursHelper'
import { WidgetMode, WidgetStatus } from 'constants/EmbedConfigurationConstants'
import { getEmbedConfig, embedLoaded } from 'app/modules/embed/selectors'
import ACCESS from 'utils/Access'
const onlineIconSrc = require('!svg-inline?removeTags=true!images/icons/check-mark-icon.svg')
const offlineIconSrc = require('!svg-inline?removeTags=true!images/icons/zz.svg')

const NOTIFICATION_TYPES = {
  ON: {
    type: 'attention',
    copy: 'Drift is online',
    icon: <IconSVG src={onlineIconSrc} />,
  },
  AWAY: {
    type: 'general',
    copy: 'Drift is offline',
    icon: <IconSVG src={offlineIconSrc} />,
  },
  OFF: { type: null, icon: null },
}

class WidgetStatusTease extends Component {
  constructor(props) {
    super(props)
    this.state = {
      seenThisStatus: props.isEmbedLoaded ? this.seenWidgetStatus() : false,
      firstLoad: true,
      closed: true,
      isOnline: props.isEmbedLoaded ? this.currentDriftStatus() : false,
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isEmbedLoaded !== prevProps.isEmbedLoaded) {
      this.setState({
        seenThisStatus: this.seenWidgetStatus(),
        isOnline: this.currentDriftStatus()
      })
    }
  }

  seenWidgetStatus = () => {
    const widgetStatus = get(this.props, 'embedConfiguration.widgetStatus', false)
    try {
      const hasSeenWidgetStatus = JSON.parse(
        window.localStorage.getItem('hasSeenWidgetStatus'),
      ) || {}
      return hasSeenWidgetStatus.lastAvailability === widgetStatus
    } catch(e) {
      console.warn("Failed to fetch hasSeenWidgetStatus from local storage")
      return false
    }
  }

  componentDidMount() {
    if (this.state.firstLoad) {
      this.setState({ firstLoad: false, closed: false })
    }
  }

  componentWillUnmount() {
    clearTimeout(this.AutoDismissOnline)
  }

  componentWillReceiveProps(nextProps) {
    if (this.seenWidgetStatus(nextProps) === this.state.seenThisStatus) return
    this.setState({ seenThisStatus: false, closed: false })
  }

  handleDismiss = () => {
    const { widgetStatus } = this.props.embedConfiguration
    this.setState({ closed: true }, () => {
      setTimeout(() => {
        try {
          window.localStorage.setItem(
            'hasSeenWidgetStatus',
            JSON.stringify({ lastAvailability: widgetStatus }),
          )
        }
        catch(e) {
          console.warn('Failed to set local storage value hasSeenWidgetStatus')
        }
        this.setState({ seenThisStatus: true })
      }, 3000)
    })
  }

  currentDriftStatus() {
    const {
      embedConfiguration: { theme: { timezone, openHours }, widgetStatus, widgetMode},
    } = this.props

    const isOpenForBusiness = areWeOpenForBusiness(timezone, openHours)
    // widgetMode is MANUAL - use ON / AWAY state
    if (widgetMode === WidgetMode.MANUAL) {
      return widgetStatus === WidgetStatus.ON
    }

    // widgetMode is AUTO - use business hours + agent status
    if (widgetMode === WidgetMode.AUTO) {
      return (openHours && openHours.length == 0) || areWeOpenForBusiness(timezone, openHours)
    }

    // widgetMode is undefined - fall back to old behavior
    return widgetStatus === WidgetStatus.ON && isOpenForBusiness

  }


  render() {
    const { type, icon, copy } = NOTIFICATION_TYPES[this.state.isOnline ? 'ON' : 'AWAY']
    const isAdmin = ACCESS.isAdmin()
    const isShown = !this.state.isOnline && isAdmin && !this.state.closed ? 'show-bar' : ''

    if (!this.props.isEmbedLoaded) {
      return null
    }

    return (
      !this.state.isOnline &&
        <div className={`global-notification-tease ${type} ${isShown}`}>
          <p>
            {icon} {copy}
          </p>
          <Link
            to="/settings/widget/hours-and-targeting"
          >
            <Button
              size="small"
              type="tertiary"
              className="notification-button drift-button small"
            >
              Update Drift’s status
            </Button>
          </Link>
          <div className="dismiss-notification" onClick={this.handleDismiss}>
            <Icon name="close" />
          </div>
        </div>

    )
  }
}

const mapStateToProps = state => ({
  embedConfiguration: getEmbedConfig(state),
  isEmbedLoaded: embedLoaded(state)
})

export default connect(mapStateToProps)(WidgetStatusTease)



// WEBPACK FOOTER //
// ./src/scripts/components/GlobalNotificationBar/components/WidgetStatusTease/index.js